import React, { useState } from 'react';

type Player = {
  id: string;
  name: string;
  status: 'confirmed' | 'tentative' | 'declined';
  isBanker: boolean;
};

const MOCK_PLAYERS: Player[] = [
  { id: '1', name: 'Alex Rivers', status: 'confirmed', isBanker: true },
  { id: '2', name: 'Jordan Smith', status: 'confirmed', isBanker: false },
  { id: '3', name: 'Casey Johnson', status: 'tentative', isBanker: false },
  { id: '4', name: 'Morgan Lee', status: 'declined', isBanker: false },
  { id: '5', name: 'Taylor Wong', status: 'confirmed', isBanker: false },
  { id: '6', name: 'Riley Davis', status: 'confirmed', isBanker: false },
  { id: '7', name: 'Sam Wilson', status: 'tentative', isBanker: false },
  { id: '8', name: 'Jamie Brown', status: 'confirmed', isBanker: false },
];

const MOCK_SEARCH_RESULTS = [
  { id: 's1', name: 'Marcus Thorne' },
  { id: 's2', name: 'Elena Vance' },
  { id: 's3', name: 'Kaelen Voss' },
];

export const DesignSandbox = () => {
  const [view, setView] = useState<'setup' | 'edit'>('setup');
  const [modalOpen, setModalOpen] = useState(false);

  React.useEffect(() => {
    console.log(`[DesignSandbox] state updated: view=${view}, modalOpen=${modalOpen}`);
  }, [view, modalOpen]);

  return (
    <div className="min-h-screen bg-aura-background flex items-center justify-center p-4 font-manrope">
        {/* Mockup Device Frame */}
        <div className="w-full max-w-[400px] bg-white border border-aura-text/10 rounded-3xl overflow-hidden flex flex-col h-[800px] relative shadow-2xl">
          
          {/* VIEW: EDIT SESSION */}
          {view === 'edit' ? (
            <div className="flex-1 flex flex-col overflow-hidden">
               <div className="p-6 pb-4">
                 <h1 className="text-2xl font-black text-aura-text">EDIT SESSION</h1>
               </div>

              
              <div className="flex-1 overflow-y-auto px-6 space-y-6">
                <div className="space-y-4">
                  <div className="flex flex-col gap-1.5">
                    <label className="text-[10px] font-black uppercase tracking-widest text-aura-text/40">
                      Session Name
                    </label>
                     <input 
                       type="text" 
                       defaultValue="Friday Night Stakes" 
                       className="bg-white border border-aura-text/10 rounded-full p-3 px-5 text-sm font-bold text-aura-text outline-none focus:border-aura-primary transition-colors"
                     />

                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div className="flex flex-col gap-1.5">
                      <label className="text-[10px] font-black uppercase tracking-widest text-aura-text/40">
                        Date
                      </label>
                       <input 
                         type="date" 
                         defaultValue="2026-04-30" 
                         className="bg-white border border-aura-text/10 rounded-full p-3 px-5 text-sm font-bold text-aura-text outline-none focus:border-aura-primary transition-colors"
                       />

                    </div>
                    <div className="flex flex-col gap-1.5">
                      <label className="text-[10px] font-black uppercase tracking-widest text-aura-text/40">
                        Time
                      </label>
                       <input 
                         type="time" 
                         defaultValue="20:00" 
                         className="bg-white border border-aura-text/10 rounded-full p-3 px-5 text-sm font-bold text-aura-text outline-none focus:border-aura-primary transition-colors"
                       />

                    </div>
                  </div>

                  <div className="flex flex-col gap-1.5">
                    <label className="text-[10px] font-black uppercase tracking-widest text-aura-text/40">
                      Buy-in
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm font-bold text-aura-text/40">$</span>
                       <input 
                         type="number" 
                         defaultValue="100" 
                         className="bg-white border border-aura-text/10 rounded-full p-3 pl-6 text-sm font-bold text-aura-text outline-none focus:border-aura-primary transition-colors w-full"
                       />

                    </div>
                  </div>
                </div>

                <div className="flex gap-3 pt-4">
                  <button 
                    onClick={() => setView('setup')}
                    className="flex-1 py-3 rounded-full bg-aura-text/5 text-aura-text text-xs font-bold uppercase tracking-wider hover:bg-aura-text/10 transition-colors"
                  >
                    Back
                  </button>
                  <button 
                    onClick={() => setView('setup')}
                    className="flex-1 py-3 rounded-full bg-aura-primary text-white text-xs font-bold uppercase tracking-wider hover:opacity-90 transition-opacity"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          ) : (
            /* VIEW: SETUP SCREEN */
            <div className="flex-1 flex flex-col overflow-hidden">
               <div className="p-6 pb-4">
                 <div className="bg-[#e8f5f0] rounded-3xl p-6 shadow-botanical mb-6">
                   <div className="flex items-center justify-between mb-1">
                     <h1 className="text-2xl font-black text-aura-text">Friday Night Stakes</h1>
                     <div className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-aura-primary/10 text-aura-primary">
                       DRAFT
                     </div>
                   </div>
                   <p className="text-aura-text/40 text-sm font-medium">April 30, 2026 • 8:00 PM</p>
                 </div>
               </div>


              <div className="flex-1 overflow-y-auto px-6 pb-6 space-y-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-[10px] font-black uppercase tracking-widest text-aura-text/40">
                    Live Roster
                  </span>
                  <div className="flex gap-2">
                    <button 
                      onClick={() => setModalOpen(true)}
                      className="text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full bg-aura-text/5 text-aura-text hover:bg-aura-text/10 transition-colors"
                    >
                      Add Player
                    </button>
                    <button 
                      onClick={() => setView('edit')}
                      className="text-[10px] font-bold uppercase tracking-wider px-3 py-1.5 rounded-full bg-aura-text/5 text-aura-text hover:bg-aura-text/10 transition-colors"
                    >
                      Edit Session
                    </button>
                  </div>
                </div>
                
                <div className="space-y-3">
                  {MOCK_PLAYERS.map((player) => (
                    <div 
                      key={player.id} 
                      className="flex items-center justify-between bg-white border border-aura-text/5 shadow-sm rounded-full px-4 py-3"
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-aura-text/5 flex items-center justify-center text-xs font-black text-aura-text/40">
                          {player.name.charAt(0)}
                        </div>
                        <div className="flex flex-col">
                          <span className={`text-sm font-bold ${player.isBanker ? 'text-aura-primary' : 'text-aura-text'}`}>
                            {player.name}
                          </span>
                          {player.isBanker && (
                            <span className="text-[8px] font-black uppercase tracking-tighter text-aura-primary opacity-70">
                              Banker
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="flex bg-aura-text/5 rounded-full p-1 gap-1">
                        <button className={`px-3 py-1 rounded-full text-[10px] font-bold transition-colors ${
                          player.status === 'confirmed' 
                            ? 'bg-emerald-500 text-white' 
                            : 'text-aura-text/40 hover:text-aura-text'
                        }`}>
                          YES
                        </button>
                        <button className={`px-3 py-1 rounded-full text-[10px] font-bold transition-colors ${
                          player.status === 'tentative' 
                            ? 'bg-amber-500 text-white' 
                            : 'text-aura-text/40 hover:text-aura-text'
                        }`}>
                          MAYBE
                        </button>
                        <button className={`px-3 py-1 rounded-full text-[10px] font-bold transition-colors ${
                          player.status === 'declined' 
                            ? 'bg-rose-500 text-white' 
                            : 'text-aura-text/40 hover:text-aura-text'
                        }`}>
                          NO
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
             </div>
         )}


        {/* ADD PLAYER MODAL */}
        {modalOpen && (
          <div 
            className="absolute inset-0 z-50 flex items-center justify-center p-6 bg-aura-background/40 backdrop-blur-sm"
            onClick={() => setModalOpen(false)}
          >
            <div 
              className="w-full max-w-sm bg-white border border-aura-text/10 rounded-3xl overflow-hidden flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-6 pb-4 flex justify-between items-center">
                <span className="text-xs font-black uppercase tracking-widest text-aura-text">
                  Add Player
                </span>
                <button 
                  onClick={() => setModalOpen(false)}
                  className="w-6 h-6 flex items-center justify-center rounded-full bg-aura-text/5 text-aura-text/40 hover:bg-aura-text/10"
                >
                  ✕
                </button>
              </div>

              <div className="px-6 pb-6 space-y-6">
                <div className="relative">
                   <input 
                     type="text" 
                     placeholder="Search players..." 
                     className="w-full rounded-full bg-aura-background/50 border border-aura-text/10 p-3 pl-3 text-sm font-medium text-aura-text outline-none focus:border-aura-primary transition-colors"
                   />

                </div>

                <div className="space-y-1">
                  <span className="text-[10px] font-black uppercase tracking-widest text-aura-text/40 px-1">
                    Suggested
                  </span>
                  <div className="space-y-1">
                    {MOCK_SEARCH_RESULTS.map(user => (
                      <button 
                        key={user.id}
                        className="w-full flex items-center justify-between p-2 rounded-full hover:bg-aura-text/5 text-sm font-bold text-aura-text transition-colors group"
                      >
                        {user.name}
                        <span className="text-aura-text/20 group-hover:text-aura-primary transition-colors">+</span>
                      </button>
                    ))}
                  </div>
                </div>

                <div className="pt-4 border-t border-aura-text/5 space-y-3">
                  <span className="text-[10px] font-black uppercase tracking-widest text-aura-text/40 px-1">
                    Add Guest
                  </span>
                  <div className="flex gap-2">
                     <input 
                       type="text" 
                       placeholder="Guest Name" 
                       className="flex-1 rounded-full bg-aura-background/50 border border-aura-text/10 p-2 px-3 text-sm font-medium text-aura-text outline-none focus:border-aura-primary transition-colors"
                     />

                    <button 
                      onClick={() => setModalOpen(false)}
                      className="bg-aura-primary text-white rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wider hover:opacity-90 transition-opacity"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* GROUNDED BOTTOM BAR */}
        <div className="bg-aura-primary text-white rounded-t-3xl p-4 flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-[10px] font-black uppercase tracking-widest text-white/60">
              {view === 'edit' ? 'Current Total' : 'Total Buy-in'}
            </span>
            <span className="text-lg font-black text-white">$1,200.00</span>
          </div>
          <button className="bg-white text-aura-primary rounded-full px-6 py-2.5 text-sm font-bold hover:bg-white/90 transition-colors flex items-center gap-2">
            <span>▶</span>
            {view === 'edit' ? 'Save Changes' : 'Finalize Setup'}
          </button>
        </div>

      </div>
    </div>
  );
};
